import {LIGHT_DEFI_INVESTMENT_RISK} from '../Reducer/LightDefiInvestmentRisk';
import {ApiLightDefiInvestmentRisk} from '../Api';

export function LightDefiInvestmentRiskThunk() {
    return (dispatch,getState)=>{
        ApiLightDefiInvestmentRisk()
        .then((result)=>{
            dispatch({
                type:LIGHT_DEFI_INVESTMENT_RISK,
                payload:{
                    result:result.data.data
                }
            })
        })
    }
}
